// Every outbound link to us in one place.
// The Alephonics app (studio, harp, library, shared scores, live events) lives
// on its own domain since the marketing / app split.
export const APP_SITE = "https://jewishmusiclab.com";

// SOCIAL = the Jazz Meets Jewish channels (podcast/method work).
export const SOCIAL = {
  instagram: "https://www.instagram.com/danberrymusic",
  youtube: "https://www.youtube.com/@jazzmeetsjewish",
  podcastPlaylist: "https://www.youtube.com/playlist?list=PLVdyJlCTjCSo",
};

// DAN_SOCIAL = Dan's own artist channels, used across danberrymusic.com.
export const DAN_SOCIAL = {
  instagram: "https://www.instagram.com/danberrymusic",
  youtube: "https://www.youtube.com/@jazzmeetsjewish",
  spotify: "https://open.spotify.com/artist/6USUBvOkAChjcancJpzgmN",
  appleMusic: "https://music.apple.com/us/artist/dan-berry/6808669102",
  // Latest release — the artist embed shows "top tracks", which is empty for a
  // new profile, so /music embeds the album itself.
  spotifyAlbum: "https://open.spotify.com/album/2iK9wQ8brZN1fudBsywvsk",
  spotifyAlbumTitle: "Vortex Vibes",
};

export const PODCAST_PLATFORMS = [
  { label: "YouTube", href: SOCIAL.podcastPlaylist },
  { label: "Spotify", href: "https://open.spotify.com/show/3v4Y9YUlkicCaspR2lpywg" },
  { label: "Apple", href: "https://podcasts.apple.com/podcast/id6804394458" },
  { label: "RSS", href: "https://rss.buzzsprout.com/2640413.rss" },
];
